"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lego = require("@zz-common/lego");
/**
 * @function
 * @name legoPerf - 性能埋点
 * @desc 性能埋点，依赖包：<a href="http://gitlab.zhuanspirit.com/zz-fe/common-zz-lego" target="_blank">@zz-common/lego</a>
 * @example
 * import { LegoPerf } from '@zz-biz/adapter';
 * 
 * // 默认性能埋点
 * LegoPerf();
 * 
 */
var _default = _lego.legoPerf;
exports["default"] = _default;